module.exports = "/assets/js/4bc8cecb7348912893ad52cff0d382a5.svg";